module.exports = __webpack_public_path__ + "img/AD.e2990f5d.svg";